import logo from "../../assets/logo.jpg";
import PriceRow from "../PriceRow";

export default function Toolbar(data?: any) {
    
    return(
    <>
        <header className="sticky top-0 z-50 bg-skin-bgHeader w-full">
            <div style={{
                    padding: data.customSize?.customLogoSize_padding ? `${data.customSize.customLogoSize_padding}px` : '32px'
                }} className="py-8 flex items-center justify-center">
                <img style={{
                    height: data.customSize?.customLogoSize_h ? `${data.customSize.customLogoSize_h}px` : '56px'
                }} className="h-14" src={data?.shopLogo && typeof data?.shopLogo === 'string' ? data.shopLogo : logo} alt="Logo Cliente"/>
            </div>
            <PriceRow />
        </header>
    </>
    )
}